import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getClient } from '@chegg/rio-sdk-web';
import { EventTypes, recordEvents } from "../../utils/newRelicEvents";
import { Step } from "../../components/MfaByEmail/MfaByEmail.types";
export function getRioClient() {
  return getClient();
}
export async function sendRioEvent(type, data) {
  try {
    await getRioClient().sendEvent({
      type: type,
      data: data,
      eventVersion: 3
    });
  } catch (error) {
    recordEvents(_defineProperty({}, EventTypes.sendRioEventFail, {
      type: type,
      data: data,
      error: error
    }));
  }
}
export function updateRioState(state) {
  getRioClient().updateState(state);
}
export function notificationsRioEvent(data) {
  return sendRioEvent('clickstream_notifications', data);
}
export function interactionRioEvent(data) {
  return sendRioEvent('clickstream_interaction', data);
}
export function successRioEvent(data) {
  return sendRioEvent('clickstream_success', data);
}
export function clickstreamViewEvent(step, authProvider) {
  if (step === Step.SendEmail) {
    updateRioState({
      view: {
        view_name: authProvider ? "mfa hard login modal - social ".concat(authProvider) : 'mfa hard login modal'
      }
    });
  }
  if (step === Step.ValidateCode) {
    updateRioState({
      view: {
        view_name: 'mfa enter code modal'
      }
    });
  }
  return sendRioEvent('clickstream_view', {});
}